export * from './update-password.component';



// WEBPACK FOOTER //
// ./src/app/login/update-password/index.ts